import { Dynamic16, ArrowDynamicUp8, ArrowDynamicDown8 } from '@cian/ui-kit/icons';
import cx from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IPriceHistoryButtonProps {
  trend?: 'inc' | 'dec' | null;
}

export function PriceHistoryButton({ trend }: IPriceHistoryButtonProps) {
  const TrendIcon = trend === 'inc' ? ArrowDynamicUp8 : ArrowDynamicDown8;

  return (
    <button type="button" className={styles['button']} title="История цены">
      <span className={styles['main']}>
        <Dynamic16 />
      </span>
      {trend && (
        <span className={cx(styles['trend'], trend === 'inc' && styles['inc'])}>
          <TrendIcon color="current_color" />
        </span>
      )}
    </button>
  );
}
